import * as React from 'react';
import { PromptTemplateBlock } from '../../types';
import { calculateWordCount, concatenateBlockBodies } from '../../misc';
import './PreviewContent.less';

interface PreviewContentProps {
    blocks: PromptTemplateBlock[];
}

const PreviewContent: React.FC<PreviewContentProps> = ({ blocks }) => {
    const previewContent = concatenateBlockBodies(blocks);
    const tokenCount = calculateWordCount(blocks);

    return (
        <div className="prompt-template-preview-content">
            <div className="header">
                <h2>Prompt Template Preview</h2>
                <div className="token-count">{tokenCount} tokens</div>
            </div>
            <div className="preview-container">{previewContent}</div>
        </div>
    );
};

export default PreviewContent;
